import React from "react";

const Footer = () => {
    return (
<footer class="page-footer font-small  darken-3">
 
  <div class="footer-copyright text-center p-3">© 2020 Copyright:
    <a href="https://github.com/vipashaaV321/"> Vipasha vaghela</a>
  </div>


</footer>
    )}
    export default Footer;
